import { useContext } from "react";
import { Box, Stack } from "@mui/material";
import { CrossRed } from "src/assets";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Text from "src/components/Displays/Text";
import officina from "src/fonts/officina.woff2";
import { SESSION_KEYS } from "src/consts/session";
import { SMART_CHARGING_ROUTES } from "src/consts/Routes/SmartCharging";
import PrimaryButton from "src/components/Shared/PrimaryButton";
import { useSessionStorage } from "src/hooks/useSessionStorage";
import { ThemeContext } from "src/components/ThemeUsage/ThemeUsage";

const Failed = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const themeName = useContext(ThemeContext);

  const [getTransferId] = useSessionStorage<string>(SESSION_KEYS.TRANSFER_ID);

  const handleTryAgain = () => {
    const transferId = getTransferId();

    navigate(
      `${
        SMART_CHARGING_ROUTES.ADD_EV_START
      }?theme=${themeName}&tid=${transferId}`,
    );
  };

  const handleContact = () => {
    window.location.href = "https://www.lichtblick.de/kontakt/";
  };

  return (
    <Stack gap={5}>
      <Stack alignItems={"start"}>
        <CrossRed />
      </Stack>

      <Text
        text={t("page.addEvFailed.pageTitle")}
        sx={(theme) => ({
          fontSize: "32px",
          fontWeight: "500",
          lineHeight: "40px",
          color: "#A1241B",
          fontFamily: "officina",
          "@font-face": {
            fontFamily: "officina",
            src: `url(${officina}) format("woff2")`,
          },
        })}
      />

      <Text
        text={t("page.addEvFailed.pageSubTitle")}
        sx={(theme) => ({
          fontSize: "14px",
          fontWeight: "400",
          lineHeight: "20px",
          fontFamily: "Inter",
        })}
      />

      <Stack gap={2}>
        <Box>
          <PrimaryButton
            onClick={handleTryAgain}
            text={t("page.addEvFailed.button1")}
            sx={(theme) => ({
              width: "100%",
              fontSize: "14px",
              lineHeight: "20px",
              maxWidth: { sm: "320px" },
              color: theme.palette.mainFont.primary,
            })}
          />
        </Box>

        <Box>
          <PrimaryButton
            sx={(theme) => ({
              fontSize: "14px",
              lineHeight: "20px",
              color: theme.palette.secondaryButton.text,
              bgcolor: "#3B3B3B",
              "&:hover": {
                backgroundColor: "#3B3B3B",
              },
              textTransform: "none",
              border: "0.829px solid #2E2E2E",
              width: "100%",
              maxWidth: { sm: "320px" },
            })}
            onClick={handleContact}
            text={t("page.addEvFailed.button2")}
          />
        </Box>
      </Stack>
    </Stack>
  );
};

export default Failed;
